import React, { useEffect } from 'react'
import styles from "./ReviewApproveForms.styles"
import TabbedNavigationWithDefinedTitle from '../../../components/tabbednavigation/TabbedNavigationWithDefinedTitle'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey, setCurrentTabIndex } from "./ReviewApproveFormsSlice"
import { TAB_PATHS } from './constants'
import Forms1099 from './1099forms/Forms1099'
import StatePayrollForms from './statepayrollreviewapproveforms/StatePayrollReviewApproveForms'
import { useLocation } from 'react-router-dom'
import { FEATURE_FLAG } from '../../../featureFlags'

const ReviewApproveForms = () => {

    const dispatch = useDispatch()
    const location = useLocation();
    const { currentTabIndex } = useSelector(state => state[componentKey])

    useEffect(() => {
        const paths = location.pathname.split("/");
        const currentPath = paths[paths.length - 1];
        let index = 0;

        switch (currentPath) {
            case TAB_PATHS['1099_FORMS']:
                index = 0;
                break;
            case TAB_PATHS.STATE_PAYROLL_FORMS:
                index = 1;
                break;
        }
        dispatch(setCurrentTabIndex(index));
    }, [location.pathname])

    const tabListWithTitleObj = [
        {
            title: {
                titleText: "Form 1099",
            },
            tabBodyComponent: <Forms1099 />,
            linkTo: `/${TAB_PATHS['1099_FORMS']}`
        },
        ...(FEATURE_FLAG.SHOW_STATE_PAYROLL ? [{
            title: {
                titleText: "State Payroll Forms",
            },
            tabBodyComponent: <StatePayrollForms />,
            linkTo: `/${TAB_PATHS.STATE_PAYROLL_FORMS}`,
        }] : []),
    ];

    return (
        <>
            <div style={styles.gridContainer}>
                <TabbedNavigationWithDefinedTitle
                    tabListWithTitleObj={tabListWithTitleObj}
                    useSeparateUrl={true}
                    sectionPath={"/forms/reviewandapprove"}
                    activeTabIndex={currentTabIndex}
                    onChangeTabCb={(activeTabIdx) => dispatch(setCurrentTabIndex(activeTabIdx))}
                    unMountChildComponentOnSwitch={true}
                />
            </div>
        </>
    )
}

export default ReviewApproveForms
